import {
  GeneralSurveyCreateInput,
  GeneralSurveyQuestionInput,
  SurveyQuestionMultipleChoiceConfigurationInput,
  SurveyQuestionSingleChoiceConfigurationInput,
  SurveyQuestionSliderConfigurationInput,
} from '@occc/graphql';

import { GeneralSurveyConfigureFormValues } from '../components/ConfigureForm/types';
import { GeneralSurveyTargetFormValues } from '../components/TargetForm/types';
import { GeneralSurveyScheduleFormValues } from '../components/ScheduleForm/types';
import { mergeDateAndTime } from '../../../lib/date';

interface ConvertFormFieldsToCreateInputParams {
  chainId: string;
  configure: GeneralSurveyConfigureFormValues;
  target: GeneralSurveyTargetFormValues;
  schedule: GeneralSurveyScheduleFormValues;
}

export const convertFormFieldsToCreateInput = ({
  configure,
  chainId,
  target,
  schedule,
}: ConvertFormFieldsToCreateInputParams): GeneralSurveyCreateInput => {
  let multipleChoice: SurveyQuestionMultipleChoiceConfigurationInput | null = null;
  let singleChoice: SurveyQuestionSingleChoiceConfigurationInput | null = null;
  let slider: SurveyQuestionSliderConfigurationInput | null = null;
  if (configure.questionType === 'SurveyQuestionIntSlider') {
    slider = {
      min: configure.rangeMin,
      max: configure.rangeMax,
    };
  }

  if (configure.questionType === 'SurveyQuestionMultipleChoice') {
    multipleChoice = {
      options: configure.options,
    };
  }

  if (configure.questionType === 'SurveyQuestionSingleChoice') {
    singleChoice = {
      options: configure.options,
    };
  }

  const question: GeneralSurveyQuestionInput = {
    text: configure.question,
    configuration: {
      multipleChoice,
      singleChoice,
      slider,
    },
  };

  const publishAt = mergeDateAndTime(schedule.publishAtDate, schedule.publishAtTime);
  const expireAt = mergeDateAndTime(schedule.expireAtDate, schedule.expireAtTime);

  return {
    chainId,
    name: configure.name,
    description: configure.description,
    audienceUuid: target.inAudience.audience.uuid,
    configuration: {
      startDate: publishAt.toISOString(),
      endDate: expireAt?.toISOString() || null,
    },
    questions: [question],
  };
};
